/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Dropdown, TextInput } from 'carbon-components-react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useFormHelpers } from '../../../../hooks/useFormHelpers';
import { AuthenticationStepMessages as messages } from '../../authentication-tab/messages';
import { FIELDS } from '../../schema';

interface ServerVariablesProps {
  /**
   *
   */
  name: string;
  /**
   *
   */
  val: any;
  /**
   *
   */
  onChange: (name: string, value: string) => void;
  /**
   *
   */
  index: number;
  /**
   *
   */
  getServerVariable: (value: any) => any;
  /**
   *
   */
  serverIndex: number;
  /**
   *
   */
  readOnly: boolean;
}

export function ServerVariables({
  readOnly,
  name,
  val,
  onChange,
  index,
  getServerVariable,
  serverIndex
}: ServerVariablesProps) {
  const formMethods = useFormContext();
  const { registerInputField } = useFormHelpers(formMethods);

  const items =
    val
      .get('enum')
      ?.map(value => value)
      .toArray() ?? null;
  const selectedItem =
    serverIndex !== -1 && !readOnly ? getServerVariable(name) : '';

  return (
    <div className="CatalogOpenApiServerVariableReview">
      {items ? (
        <Dropdown
          {...registerInputField({
            field: FIELDS.SERVER_VARIABLE_VALUE(name),
            readOnly
          })}
          label={name}
          titleText={name}
          light
          id={`server-variable-${index}`}
          items={items}
          onChange={(event: any) =>
            !readOnly &&
            onChange(name, (event.target as any)?.value || event?.selectedItem)
          }
          selectedItem={selectedItem}
        />
      ) : (
        <TextInput
          {...registerInputField({
            field: FIELDS.SERVER_VARIABLE_VALUE(name),
            labelText: name,
            placeholderText: messages.serverVarPlaceholder,
            readOnly
          })}
          onChange={event =>
            !readOnly &&
            onChange(name, (event.target as HTMLInputElement).value)
          }
          light
          id={`server-variable-${index}`}
        />
      )}
    </div>
  );
}
